import { Component, OnInit, Injector, HostListener } from '@angular/core';
import { PageFormComponent } from '../../../forms/page-form.component';
import { RoutingDataService } from 'src/app/submodules/angular-common/routing-data.service';
import { Router } from '@angular/router';
import { SecurityDataService } from 'src/app/submodules/angular-common/security-data.service';
import { navigateToSamePage } from 'src/app/submodules/angular-common/util';
import { isClassPresentInDomEventTarget } from 'src/app/submodules/angular-common/util';
import { Color } from 'src/app/config/color';
import { FormSettings } from '../../../forms/form-settings';
import { EnvironmentDataService } from 'src/app/submodules/angular-common/environment-data.service';
import * as pkg from '../../../../../../../package.json';
import { FileDto } from '../../../base-types';

@Component({
  selector: 'app-set-or-reset-password-step1',
  templateUrl: './set-or-reset-password-step1.component.html',
  styleUrls: ['./set-or-reset-password-step1.component.scss']
})
export class SetOrResetPasswordStep1Component extends PageFormComponent {

  public bgColor = Color.auxiliary;
  public submitDone:boolean = false; //true se effettuato almeno un submit e quindi viene mostrato il messaggio di feedback

  public routingDataService = this._injector.get(RoutingDataService);
  public environmentDataService = this._injector.get(EnvironmentDataService);

  constructor(protected _injector: Injector) { 
    super(_injector);
  }

  ngOnInit(): void {
    this.init()
  }

  @HostListener('document:click', ['$event'])
  private onClick(event) {
    if(isClassPresentInDomEventTarget(event, 'retry'))  
      this.retry()
  }

  /** @override */
  protected async _initSettingsHook(): Promise<FormSettings> {
    return {
      fieldsSettings: {
        username: { required: true, allowBlanks: false }
      }
    }
  }

  /** @override */
  protected async _setDatasourceHook(): Promise<{ [key: string]: string | number | boolean | (string | number)[] | File | File[] }> {
    return {}
  }

  /** @override */
  protected async _submitHook() {
    //ritornano sempre 200 anche in caso di username non esistente per motivi di sicurezza
    if(this._injector.get(RoutingDataService).currentRoutingNodeId=='set_password')
      await this._injector.get(SecurityDataService).requirePasswordSetting(this.currentValues.username as string,pkg.name.replace(pkg.group+'-',''));
    else
      await this._injector.get(SecurityDataService).requirePasswordReset(this.currentValues.username as string,pkg.name.replace(pkg.group+'-',''));
    this.submitDone = true
  }

  async cancel(){
    this._injector.get(Router).navigate(['/']);
  }

  retry(){
    const url = this._injector.get(RoutingDataService).currentRoutingNodeId=='set_password'?'/set-password':'/reset-password';

    //triangolare per ricaricare la pagina
    navigateToSamePage(this._injector, url)
  }
}